import tw from "twin.macro";

export const SectionHeading = tw.h2`text-4xl sm:text-5xl font-black tracking-wide text-center`

export const Subheading = tw.h5`font-bold text-primary-500`
export const ExpecteLink = tw.h6`text-xl sm:text-2xl font-black tracking-wide text-left mt-4`; // Added margin-top
export const Step4and5 = tw.h6`text-xl sm:text-2xl font-black tracking-wide text-left mt-4`;
export const SectionSteps = tw.h2`text-4xl sm:text-5xl font-extrabold  tracking-wide text-center`
export const SectionFooter = tw.h5`ml-10 font-bold text-lg uppercase font-extrabold  `